import React from 'react';
import { useSubscriptionImport } from './SubscriptionImportContext';

const SubscriptionStep3Match: React.FC = () => {
  const {
    newSubscriptions,
    existingCount,
    handleToggleSubscription,
    handleSelectAll,
    handleDeselectAll,
  } = useSubscriptionImport();

  const selectedCount = newSubscriptions.filter((s) => s.selected).length;

  return (
    <div className="matching-section">
      <div className="matching-summary">
        <div className="summary-card new">
          <h4>Neue Abonnements</h4>
          <div className="count">{newSubscriptions.length}</div>
        </div>
        <div className="summary-card existing">
          <h4>Bereits vorhanden</h4>
          <div className="count">{existingCount}</div>
        </div>
      </div>

      {newSubscriptions.length > 0 ? (
        <div className="new-subscriptions-table">
          <h3>Neue Abonnements zum Importieren:</h3>
          <div className="select-all-section">
            <button className="select-btn" onClick={handleSelectAll}>
              Alle auswählen
            </button>
            <button className="select-btn" onClick={handleDeselectAll}>
              Alle abwählen
            </button>
            <span style={{ marginLeft: 'auto', color: '#666' }}>
              {selectedCount} von {newSubscriptions.length} ausgewählt
            </span>
          </div>
          <table className="import-table">
            <thead>
              <tr>
                <th style={{ width: '50px' }}>✓</th>
                <th>Beschreibung</th>
                <th style={{ width: '120px' }}>Typ</th>
              </tr>
            </thead>
            <tbody>
              {newSubscriptions.map((sub, idx) => (
                <tr key={idx} className={sub.selected ? 'selected' : ''}>
                  <td>
                    <input
                      type="checkbox"
                      className="select-checkbox"
                      checked={sub.selected}
                      onChange={() => handleToggleSubscription(idx)}
                    />
                  </td>
                  <td>{sub.description}</td>
                  <td>{sub.type}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="no-data-message">
          Alle Einträge aus der Excel-Datei sind bereits als Abonnements vorhanden.
        </div>
      )}
    </div>
  );
};

export default SubscriptionStep3Match;
